import React from 'react';
import { useLocation } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';

/**
 * Redirect handles the callback from the QuickBooks authorization flow.
 * It's opened as a popup by the QuickBooks button.
 * It reads the code and realmId from the query string and posts a message
 * to the window that opened it with the code and realmId.
 * The window that opened it is responsible for exchanging the code for an access token.
 */
const Redirect: React.FC<unknown> = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const realmId = searchParams.get('realmId');
  const state = searchParams.get('state');

  if (code || realmId || state) {
    if (window.opener) {
      window.opener.postMessage(
        {
          code,
          realmId,
          state,
        },
        '*'
      );
      window.close();
    }
  }
  return <LogoLoader />;
};
export default Redirect;
